// Library Imports
import React, { Component } from "react";
import $ from "jquery";
import ReactHTMLParser from "react-html-parser";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as moment from "moment";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// Service Imports
import { LoginService } from "../../services/login.service";
import { FetchNotificationService } from "../../services/fetchnotification";
import { FeedbackService } from "../../services/feedback.service";
// Reducer Imports
import {
  getUserRoleAcess,
  getUserRoleAcessError,
  getUserRoleAcessPending,
} from "../../reducer/roleAccessReducer";
// Other Imports
import {
  warningNotification,
  warning,
  error,
  errorNotification,
  success,
  successNotification,
} from "../../components/notification/notifications";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
// Asset Imports
const Finxlogo = require("../../assets/images/dapIcon.png");

const mapStateToProps = (state) => ({
  userRoleAccess: getUserRoleAcess(state.roleAccessReducer),
  pendingUserRoleAccess: getUserRoleAcessPending(state.roleAccessReducer),
  errorUserRoleAccess: getUserRoleAcessError(state.roleAccessReducer),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const connectFunction = connect(mapStateToProps, mapDispatchToProps);

const DashboardHeader = connectFunction(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        alertcount: "",
        notificationcount: "",
        alertNotificationEvents: JSON.parse(
          localStorage.getItem("AdminAlertNotification"),
        ),
        // inboxCount: this.props.inboxCount ? this.props.inboxCount : "",
        inboxCount: "",
        emailid: "",
        partyid: "",
        rank: 0,
        feedbackMsg: "",
        loading: false,
        loading1: false,
        loading2: false,
        // notificationEvents: this.props.notificationEvents1
        //   ? this.props.notificationEvents1
        //   : [],
        notificationEvents: [],
        saveFeedbackBtnDisabled: false,
        typeOfConcernList: [],
        typeOfConcernList1: [
          {
            concernID: 1,
            concernName: "Unable to generate OTP",
          },
          {
            concernID: 2,
            concernName: "Site is very slow",
          },
          {
            concernID: 3,
            concernName: "Not able to make the payment",
          },
          {
            concernID: 4,
            concernName: "Not able to upload the documents",
          },
          {
            concernID: 5,
            concernName: "Site is not intuitive",
          },
          {
            concernID: 6,
            concernName: "Others",
          },
        ],
        disabledLink: false || this.props?.profileLinkDisabled,
      };
    }
    getConcernTypeList = () => {
      this.setState({ loading: true });
      FeedbackService.getConcernTypeList(
        (cb) => {
          if (cb.status === "success") {
            this.setState({ loading: false });
            this.setState({ typeOfConcernList: cb.responseListObject });
          } else {
            error(cb.status, errorNotification);
            this.setState({ loading: false });
          }
        },
        (err) => console.error("Error", err),
      );
    };

    componentDidMount() {
      this.getConcernTypeList();
      if (this.props.data !== undefined) {
        this.setState({
          email:
            JSON.parse(localStorage.getItem("login"))["emailId"] === undefined
              ? ""
              : JSON.parse(localStorage.getItem("login"))["emailId"],
          partyid:
            JSON.parse(localStorage.getItem("login"))["partyId"] === undefined
              ? ""
              : JSON.parse(localStorage.getItem("login"))["partyId"],
        });
      }

      var header2 = document.getElementById("myDIV");
      var btns2 = header2.getElementsByClassName("emoji");
      for (var i = 0; i < btns2.length; i++) {
        btns2[i].addEventListener("click", function () {
          var current = document.getElementsByClassName("active");
          if (current.length > 0) {
            current[0].className = current[0].className.replace(" active", "");
          }
          this.className += " active";
        });
      }

      // if (this.props.apiCall === true) {
      // this.props.apiCallPropsSet(false, []);
      // let partyID = localStorage.getItem("ciel-userid-Token");
      // this.setState({ loading1: true });
      // FetchNotificationService.fetchNotification(
      //   "partyId=" + partyID,
      //   (res1) => {
      //     if (res1.responseListObject?.length > 0) {
      //       this.setState({
      //         notificationEvents: res1.responseListObject,
      //         loading1: false,
      //       });
      //       this.props.apiCallPropsSet(false, res1.responseListObject);
      //     } else {
      //       this.setState({
      //         notificationEvents: [],
      //         loading1: false,
      //       });
      //     }
      //   },
      // );
      // }
      this.extentendedFun();

      // if (this.props.apiCall1 === true) {
      // this.props.apiCallPropsSet1(false, "");
      let senderPartyId = localStorage.getItem("ciel-userid-Token");
      this.setState({
        loading2: true,
      });
      FetchNotificationService.getCount(
        "senderPartyId=" + senderPartyId,
        (res1) => {
          if (res1.status === "success") {
            this.setState({
              inboxCount: res1.responseObject.unreadCount,
              loading2: false,
            });
            // this.props.apiCallPropsSet1(false, res1.responseObject.unreadCount);
          } else {
            this.setState({
              loading2: false,
            });
          }
        },
      );
      // }

      $("button").bind("click", function (e) {
        if ([0, "0"].includes($(e.target).closest("#navbar").length)) {
          // click happened outside of .navbar, so hide
          var opened = $(".navbar-collapse").hasClass("collapse in");
          if (opened === true) {
            $(".navbar-collapse").removeClass("in");
          }
        }
      });

      $("body").bind("click", function (e) {
        if ([0, "0"].includes($(e.target).closest("#navbar").length)) {
          // click happened outside of .navbar, so hide
          var opened = $(".navbar-collapse").hasClass("collapse in");
          if (opened === true) {
            $(".navbar-collapse").removeClass("in");
          }
        }
      });
      setTimeout(() => {
        const personnelData = ![
          "",
          null,
          undefined,
          "null",
          "undefined",
        ].includes(localStorage?.getItem("PersonnelData"))
          ? JSON.parse(localStorage?.getItem("PersonnelData"))
          : {};
        const {
          responseCode,
          learnerEuinOption,
          mandateId,
          learnerAdditionalEntity,
          nismRenewFlag,
          // profileRedirectionFlag,
        } = personnelData?.responseObject || {};
        const checkLearnerEuinOption = new Set(["other", "others"]).has(
          learnerEuinOption?.toLowerCase(),
        );
        const disabledCodes = new Set([
          "A0001",
          "A0005",
          "A0006",
          "A0007",
          "A0009",
          "A0010",
        ]);
        // const redirectValidation = new Set(["N", "n", null, undefined]);
        var mandateName =
          personnelData?.responseObject?.mandateName ||
          localStorage.getItem("assignedUserMandateName") ||
          localStorage.getItem("preferredMandateName") ||
          JSON.parse(localStorage?.getItem("mandateDetails"))?.mandateName ||
          {};
        console.log(
          `check mm DashboardHeader\n` +
            `mandateName: ${mandateName} , mandateId: ${mandateId}`,
        );
        const checkNismRenewFlag =
          new Set([3, "3"]).has(nismRenewFlag) &&
          ["NISM and EUIN", "NISM_EUIN_IRDA"].includes(mandateName);
        if (!["NISM"].includes(mandateName) && ![4, "4"].includes(mandateId)) {
          console.log(
            `check mm DashboardHeader disabled profile link condition\n` +
              `learnerEuinOption: ${learnerEuinOption} , responseCode: ${responseCode}\n` +
              // `profileRedirectionFlag: ${profileRedirectionFlag}\n` +
              `props profileLinkDisabled: ${this.props?.profileLinkDisabled}\n` +
              `nismRenewFlag: ${nismRenewFlag} and Mandate Name: ${mandateName}\n` +
              `if LearnerEuinOption: other,others || responseCode: A0001,A0005,A0006,A0007,A0009,A0010\n` +
              // `if profileRedirectionFlag:  N,n,null,undefined` +
              `if props profileLinkDisabled: true\n` +
              `if nismRenewFlag is 3 and Mandate Name: NISM and EUIN or NISM_EUIN_IRDA\n` +
              `Then Profile Link Will be Disabled`,
          );
          console.log(
            "check mm DashboardHeader disabled profile link",
            checkLearnerEuinOption,
            responseCode && disabledCodes.has(responseCode),
            // redirectValidation.has(profileRedirectionFlag),
            [true, "true"].includes(this.props?.profileLinkDisabled),
            checkNismRenewFlag,
          );
          const irdaProfileRespCodes = new Set([
            "A0001",
            "A0005",
            "A0006",
            "A0007",
            "A0009",
            "A0010",
            "A0011",
            "B0001",
            "B0002",
            "B0003",
            "B0004",
            "B0005",
            "B0006",
            "B0007",
            "B0008",
            "B0009",
            "B0010",
            "B0011",
            "B0012",
            "B0013",
            "B0014",
            "B0015",
            "B0016",
            "B0017",
            "B0019",
            "B0021",
            "B0022",
            "B0023",
            "B0024",
            "B0025",
            "B0026",
            "B0027",
            "B0028",
            "B0029",
            "B0030",
            "D0001",
            "D0002",
            "D0003",
            "D0005",
            "D0006",
            "D0007",
            "D0008",
            "D0009",
            "D0011",
            "E0001",
            "E0002",
            "E0003",
            "E0004",
            "E0005",
            "E0007",
            "E0008",
            "E0009",
            "E0010",
            "E0011",
            "E0012",
            "E0013",
          ]);
          const shouldRedirect =
            mandateName === "NISM_EUIN_IRDA" &&
            irdaProfileRespCodes.has(responseCode);
          // && learnerAdditionalEntity &&
          // learnerAdditionalEntity?.irdaApplicationStatus !==
          //   "IRDA PROFILE COMPLETED";
          if (shouldRedirect) {
            this.setState({ disabledLink: false });
            localStorage.setItem("isIrdaProfileAccess", "true");
          } else if (
            checkLearnerEuinOption ||
            (responseCode && disabledCodes.has(responseCode)) ||
            // redirectValidation.has(profileRedirectionFlag) ||
            [true, "true"].includes(this.props?.profileLinkDisabled)
            // || checkNismRenewFlag
          ) {
            this.setState({ disabledLink: true });
            localStorage.setItem("isIrdaProfileAccess", "false");
          }
        }
      }, 7500);
    }
    componentDidUpdate(prevProps) {
      const { profileLinkDisabled } = this.props;
      if (
        [true, "true"].includes(profileLinkDisabled) && // only run if true
        prevProps.profileLinkDisabled !== profileLinkDisabled && // prop changed
        this.state.disabledLink !== true // only set if not already set
      ) {
        this.setState({ disabledLink: true });
        localStorage.setItem("isIrdaProfileAccess", "false");
      }
    }
    componentWillReceiveProps(props) {
      this.setState({
        notificationEvents: props.notificationEvents1,
        // inboxCount: props.inboxCount,
      });
    }

    extentendedFun() {
      $(window).blur(function () {
        window.addEventListener("storage", (e) => {
          if (
            localStorage.getItem("userid-Token") === null &&
            localStorage.getItem("login") === null
          ) {
            if (localStorage.getItem("windowloggedout") === true) {
              window.location.href = "/";
            }
          }
          e.currentTarget.removeEventListener("storage", e);
        });
      });
      if (
        localStorage.getItem("userid-Token") !== null &&
        localStorage.getItem("login") !== null
      ) {
        if ([5, "5"].includes(localStorage.getItem("roleId"))) {
          if (localStorage.getItem("checkedtab") === false) {
            localStorage.setItem("checkedtab", true);
            window.location.replace("/learnerDashboard");
          }
        } else {
          if (localStorage.getItem("checkedtab") === false) {
            localStorage.setItem("checkedtab", true);
            window.location.replace("/admin-dashboard");
          }
        }
      } else {
        if (
          ["false", "false", false].includes(localStorage.getItem("checkedtab"))
        ) {
          localStorage.setItem("checkedtab", false);
          window.location.href = "/";
        }
      }

      $(".popup10").click(function () {
        $("#myPopup10").toggleClass("show");
        setTimeout(function () {
          $("#myPopup10").toggleClass("show");
        }, 2000);
      });

      $(".popup11").click(function () {
        $("#myPopup11").toggleClass("show");
        setTimeout(function () {
          $("#myPopup11").toggleClass("show");
        }, 2000);
      });

      $(document).ready(function () {
        $(".popup13").click(function () {
          $("#myPopup13").toggleClass("show");
          setTimeout(function () {
            $("#myPopup13").toggleClass("show");
          }, 2000);
        });

        $("#myBtn").click(function () {
          $("#mySidenav").toggleClass("opensidenav");
          $(".dropdown-container").hide();
        });

        $(".popup14").click(function () {
          $("#myPopup14").toggleClass("show");
          setTimeout(function () {
            $("#myPopup14").toggleClass("show");
          }, 2000);
        });

        $(".popup15").click(function () {
          $("#myPopup15").toggleClass("show");
          setTimeout(function () {
            $("#myPopup15").toggleClass("show");
          }, 2000);
        });

        $(".popup16").click(function () {
          $("#myPopup16").toggleClass("show");
          setTimeout(function () {
            $("#myPopup16").toggleClass("show");
          }, 2000);
        });

        $(".popup17").click(function () {
          $("#myPopup17").toggleClass("show");
          setTimeout(function () {
            $("#myPopup17").toggleClass("show");
          }, 2000);
        });

        $(".popup18").click(function () {
          $("#myPopup18").toggleClass("show");
          setTimeout(function () {
            $("#myPopup18").toggleClass("show");
          }, 2000);
        });

        $(".popup19").click(function () {
          $("#myPopup19").toggleClass("show");
          setTimeout(function () {
            $("#myPopup19").toggleClass("show");
          }, 2000);
        });

        $(".popup20").click(function () {
          $("#myPopup20").toggleClass("show");
          setTimeout(function () {
            $("#myPopup20").toggleClass("show");
          }, 2000);
        });

        $(".popup21").click(function () {
          $("#myPopup21").toggleClass("show");
          setTimeout(function () {
            $("#myPopup21").toggleClass("show");
          }, 2000);
        });
        $(".popup22").click(function () {
          $("#myPopup22").toggleClass("show");
          setTimeout(function () {
            $("#myPopup22").toggleClass("show");
          }, 2000);
        });
        $(".popup23").click(function () {
          $("#myPopup23").toggleClass("show");
          setTimeout(function () {
            $("#myPopup23").toggleClass("show");
          }, 2000);
        });
      });

      $("#return-to-top").click(function () {
        $("body,html").animate(
          {
            scrollTop: 0,
          },
          500,
        );
      });

      var dropdown = document.getElementsByClassName("dropdown-btn");
      for (var i = 0; i < dropdown.length; i++) {
        dropdown[i].addEventListener("click", function () {
          $(".dropdown-container").hide("active");

          this.classList.toggle("active");
          var dropdownContent = this.nextElementSibling;
          if (dropdownContent.style.display === "none") {
            dropdownContent.style.display = "block";
          } else {
            dropdownContent.style.display = "none";
          }
        });
      }
    }

    signout = (event) => {
      event.preventDefault();
      this.setState({ loading: true });
      if (
        localStorage.getItem("roleName") === "DISTRIBUTOR" &&
        localStorage.getItem("login") !== null
      ) {
        var data1 = localStorage.getItem("PersonnelData");
        var data = {
          userName: JSON.parse(data1).responseObject.emailID,
          userId: JSON.parse(localStorage.getItem("login"))["userId"],
        };

        LoginService.LogoutUser(data, false, (res) => {
          if (res.status === "success") {
            this.setState({ loading: false });
            localStorage.clear();
            localStorage.setItem("windowloggedout", true);
            var email = data.userName;
            var partyid = JSON.parse(data1).responseObject.learnerPartyID;
            localStorage.setItem("showFeedback", "true");
            this.props.history.push("/", { email, partyid });
          } else {
            this.setState({ loading: false });
            warning(res.reasonText, warningNotification);
          }
        });
      } else if (
        localStorage.getItem("roleName") === "CIEL OPS" &&
        localStorage.getItem("login") !== null
      ) {
        var data2 = {
          userName: JSON.parse(localStorage.getItem("login"))["userName"],
          userId: JSON.parse(localStorage.getItem("login"))["userId"],
        };

        LoginService.LogoutUser(data2, false, (res) => {
          if (res.status === "success") {
            this.setState({ loading: false });
            localStorage.clear();
            localStorage.setItem("windowloggedout", true);
            window.location.href = "/";
          } else {
            this.setState({ loading: false });
            warning(res.reasonText, warningNotification);
          }
        });
      } else {
        this.setState({ loading: false });
        window.location.href = "/";
      }
    };

    changepassword = () => {
      this.props.history.push("/changepassword", {
        alerts: this.state.alertNotificationEvents,
        notification: this.state.notificationEvents,
      });
    };

    userprofile = () => {
      this.props.history.push("/userprofile", {
        alertNotificationEvents: this.state.alertNotificationEvents,
        notificationEvents: this.state.notificationEvents,
      });
    };

    alerts = (key) => {
      if (this.state.alertNotificationEvents.length > 0) {
        this.props.history.push("/myalerts", {
          alertid: key,
          alerts: this.state.alertNotificationEvents,
        });
      }
    };

    alert = () => {
      if (this.state.alertNotificationEvents.length > 0) {
        this.props.history.push("/myalerts", {
          alertid: 0,
          alerts: this.state.alertNotificationEvents,
        });
      }
    };

    notifications = () => {
      var notealertdata = JSON.parse(localStorage.getItem("AdminNotification"));
      if (
        this.state.notificationEvents?.length > 0 ||
        notealertdata?.length > 0
      ) {
        this.props.history.push("/my-inbox", {
          alertid: 0,
          notification: notealertdata,
        });
      } else {
        warning("No record found", warningNotification);
      }
    };

    notification = (key, object) => {
      if (object.read_unread === false) {
        let notifyHistory = {
          notifyHistoryId: key,
        };
        FetchNotificationService.updateReadUnread(notifyHistory, (res2) => {
          if (res2.status === "success") {
            let senderPartyId = localStorage.getItem("ciel-userid-Token");
            FetchNotificationService.getCount(
              "senderPartyId=" + senderPartyId,
              (res1) => {
                this.setState({
                  inboxCount: res1.responseObject.unreadCount,
                });
              },
            );
          }
        });
      }
      if (this.state.notificationEvents.length > 0) {
        let arrayObj = [];
        arrayObj.push(object);
        this.props.history.push("/notification", {
          alertid: key,
          notification: arrayObj,
          value: "Inbox",
          inboxCount: this.state.inboxCount,
        });
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      }
    };
    order = () => {
      this.props.history.push("/my-orders", {
        alerts: this.props.alertNotificationEvents,
        notification: this.props.notificationEvents,
      });
    };

    inbox = () => {
      this.props.history.push("/my-inbox", {
        alerts: this.props.alertNotificationEvents,
        notification: this.props.notificationEvents,
      });
    };
    reattempt = () => {
      this.props.history.push("/PreassessmentView");
    };
    dateRequest = () => {
      window.location.href = "/dateRequest";
    };

    updateScore = () => {
      window.location.href = "/uploadScore";
    };

    uploadExamDate = () => {
      window.location.href = "/uploadExamDate";
    };

    uploadNism = () => {
      window.location.href = "/uploadNism";
    };

    updatePayment = () => {
      window.location.href = "/updateWfToPaymentComplete";
    };
    nigoMark = () => {
      window.location.href = "/nigoMark";
    };

    updatePersonalDetails = () => {
      window.location.href = "/updatePersonalDetails";
    };

    createMail = () => {
      this.props.history.push("/my-inbox-create", {
        alerts: this.props.alertNotificationEvents,
        notification: this.props.notificationEvents,
        userRoleAccess: this.props.userRoleAccess,
      });
    };
    schedular = () => {
      window.location.href = "/Schedular";
    };
    cielReport = () => {
      window.location.href = "/ciel-report";
    };

    empanellementReport = () => {
      window.location.href = "/empanellement-report";
    };

    mandateReport = () => {
      window.location.href = "/mandate-report";
    };
    camsEuinReport = () => {
      window.location.href = "/camsEuinReport";
    };
    camsEuinErrorReport = () => {
      window.location.href = "/camsEuinErrorReport";
    };
    CamsApiIntegration = () => {
      this.props.history.push("/uploadPAN");
    };
    feedBack = () => {
      this.props.history.push("/ops-feedback-report", {
        typeOfConcernList: this.state.typeOfConcernList,
      });
    };
    getInTouch = () => {
      this.props.history.push("/ops-getintouch-report");
    };
    handleClose = () => {
      this.setState({ rank: 0, feedbackMsg: "" });
      const child = document.querySelectorAll(".emoji");
      child.forEach((element) => {
        element.classList.remove("active");
      });
    };
    fetchLatestNotifications = () => {
      let partyID = localStorage.getItem("ciel-userid-Token");
      if (partyID) {
        this.setState({ loading1: true });
        FetchNotificationService.fetchNotification(
          "partyId=" + partyID,
          (res1) => {
            if (res1.responseListObject?.length > 0) {
              this.setState({
                notificationEvents: res1.responseListObject,
                loading1: false,
              });
            } else {
              this.setState({
                notificationEvents: [],
                loading1: false,
              });
            }
          },
        );
      }
    };
    render() {
      console.log("Dashboard Header Debug", {
        Props: this.props,
        State: this.state,
      });
      // var notealertdata = this.state.notificationEvents;
      return (
        <div>
          <React.Fragment>
            <PopUpPortal
              HidePopup={
                this.state.loading || this.state.loading1 || this.state.loading2
              }
              IsVisible={
                this.state.loading || this.state.loading1 || this.state.loading2
              }
            />
            <section className="header">
              <nav className="navbar navbar navbar-fixed-top">
                <span id="myBtn" className="sidenva-icon sidebartogglexyz">
                  &#9776;
                </span>

                <div className="container-fluid">
                  {/* <!-- Brand/logo --> */}
                  <div className="navbar-header">
                    <button
                      type="button"
                      className="navbar-toggle collapsed"
                      data-toggle="collapse"
                      data-target="#navbar"
                      aria-expanded="false"
                      aria-controls="navbar"
                    >
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                    {[5, "5"].includes(localStorage.getItem("roleId")) ? (
                      <a className="navbar-brand" href="/learnerdashboard">
                        <img src={Finxlogo} alt="Finx Logo" />
                      </a>
                    ) : (
                      <a className="navbar-brand" href="/dashboard">
                        <img src={Finxlogo} alt="Finx Logo" />
                      </a>
                    )}
                  </div>
                  <button
                    id="md-toggle"
                    className="navbar-toggler hidden-sm hidden-xs"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbar"
                    aria-controls="navbar"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="dark-blue-text">
                      <i className="fa fa-bars"></i>
                    </span>
                  </button>
                  <div id="navbar" className="navbar-collapse collapse">
                    <ul className="nav navbar-nav navbar-right">
                      <li
                        className="nav-item dropdown notification"
                        id="user-option"
                      >
                        <a
                          href
                          className="nav-link text-light notification"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          title="My Profile"
                        >
                          <i className="fa fa-user" aria-hidden="true"></i>{" "}
                          Profile
                          <span className="popup23 popuptext" id="">
                            Coming Soon...
                          </span>
                        </a>

                        <ul
                          className="dropdown-menu"
                          id="notification-profile"
                          style={{ width: "auto !important" }}
                        >
                          <li className="notification-box">
                            <div className="row">
                              <div className="panel-body">
                                <div className="notification-content">
                                  <div className="col-lg-12 col-sm-12 col-12">
                                    {[5, "5"].includes(
                                      localStorage.getItem("roleId"),
                                    ) ? (
                                      <a
                                        href
                                        className="text-light"
                                        style={{
                                          pointerEvents: this.state.disabledLink
                                            ? "none"
                                            : "",
                                          color: this.state.disabledLink
                                            ? "gray"
                                            : "",
                                          textDecoration: this.state
                                            .disabledLink
                                            ? "none"
                                            : "",
                                          cursor: this.state.disabledLink
                                            ? "not-allowed"
                                            : "",
                                        }}
                                        onClick={this.userprofile}
                                      >
                                        My Profile
                                      </a>
                                    ) : (
                                      ""
                                    )}

                                    <a
                                      href
                                      onClick={this.changepassword}
                                      className="text-light "
                                    >
                                      Change Password
                                    </a>

                                    <a
                                      href
                                      onClick={this.signout}
                                      className="text-light"
                                    >
                                      Sign Out
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown notification">
                        <a
                          href
                          className="nav-link text-light notification"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          title="Messages"
                          onClick={() => {
                            this.fetchLatestNotifications();
                          }}
                        >
                          <i
                            className="fa fa-envelope-o"
                            aria-hidden="true"
                          ></i>{" "}
                          Messages ({this.state.inboxCount})
                        </a>
                        <ul className="dropdown-menu" id="notification-alert">
                          <li className="head text-light bg-dark">
                            <div className="row">
                              <div className="col-lg-12 col-sm-12 col-12">
                                <span>Messages ({this.state.inboxCount})</span>
                                <a href className="text-light pull-right">
                                  {" "}
                                </a>
                              </div>
                            </div>
                          </li>

                          <li className="notification-box">
                            <div className="row">
                              <div className="panel-body">
                                <div className="col-lg-12 col-sm-12 col-12">
                                  {/* {notealertdata
                                    ? notealertdata */}
                                  {this.state.notificationEvents
                                    ? this.state.notificationEvents
                                        .slice(0, 3)
                                        .map((item, key) => (
                                          <div
                                            className="notification-content"
                                            id={item.notifyHistoryId}
                                          >
                                            <a
                                              href
                                              onClick={() =>
                                                this.notification(
                                                  item.notifyHistoryId,
                                                  item,
                                                )
                                              }
                                            >
                                              <div className="notification-body">
                                                <strong
                                                  className={
                                                    "text-info " +
                                                    (item.read_unread
                                                      ? "unread"
                                                      : "")
                                                  }
                                                >
                                                  {item.fromEmailId}
                                                </strong>
                                                <div className="notification-body">
                                                  {ReactHTMLParser(
                                                    item.emailSubjectText,
                                                  )}
                                                </div>
                                                <small className="text-warning">
                                                  {moment(
                                                    item.lastAttemptDatetime.split(
                                                      " ",
                                                    )[0],
                                                    "DD/MM/YYYY",
                                                  ).format("DD-MM-YYYY") +
                                                    " " +
                                                    item.lastAttemptDatetime.split(
                                                      " ",
                                                    )[1]}
                                                </small>
                                              </div>
                                            </a>
                                          </div>
                                        ))
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="footer bg-dark text-center">
                            <a
                              href
                              onClick={this.notifications}
                              className="text-light"
                            >
                              View All
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown notification">
                        <a
                          href
                          onClick={this.signout}
                          className="nav-link text-light notification"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          title="Sign-Out"
                        >
                          <i className="fa fa-sign-out" aria-hidden="true"></i>{" "}
                          Sign Out
                        </a>
                      </li>
                      {localStorage.getItem("roleName") === "DISTRIBUTOR" &&
                        localStorage.getItem("login") !== null && (
                          <li className="nav-item dropdown notification">
                            <a
                              href
                              className="nav-link text-light notification"
                              id="navbarDropdown"
                              role="button"
                              onClick={(e) => {
                                this.setState({
                                  saveFeedbackBtnDisabled: false,
                                  rank: 0,
                                  feedbackMsg: "",
                                });
                                const child =
                                  document.querySelectorAll(".emoji");
                                child.forEach((element) => {
                                  element.classList.remove("active");
                                });
                                window.$("#feedback-modal").modal("show");
                              }}
                              title="Feedback"
                            >
                              <i
                                className="fa fa-regular fa-comments"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
              </nav>
            </section>

            {/* <!--------------- Left Side navbar -------------> */}
            <div id="mySidenav" className="sidenav sidebartogglexyz">
              {[5, "5"].includes(localStorage.getItem("roleId")) ? (
                <a href="/learnerDashboard" className="sidebartogglexyz">
                  <i className="fa fa-pie-chart" aria-hidden="true"></i>{" "}
                  Dashboard
                </a>
              ) : (
                <a href="/dashboard" className="sidebartogglexyz">
                  <i className="fa fa-pie-chart" aria-hidden="true"></i>{" "}
                  Dashboard
                </a>
              )}
              <div>
                <a href="/my-inbox" className="sidebartogglexyz">
                  <i
                    className="fa fa-bell sidebartogglexyz"
                    aria-hidden="true"
                  ></i>{" "}
                  Notification Manager
                </a>
              </div>
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <button className="dropdown-btn sidebartogglexyz">
                    <i
                      className="fa fa-leanpub sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    NISM Exam Date Request
                    <i className="fa fa-caret-down sidebartogglexyz"></i>
                  </button>

                  <div className="dropdown-container sidebartogglexyz">
                    <a
                      href
                      onClick={this.dateRequest}
                      className="sidebartogglexyz"
                    >
                      NISM Exam Date Request List
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <button className="dropdown-btn sidebartogglexyz">
                    <i
                      className="fa fa-edit sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    Update NISM Scores
                    <i className="fa fa-caret-down sidebartogglexyz"></i>
                  </button>

                  <div className="dropdown-container sidebartogglexyz">
                    <a
                      href
                      onClick={this.updateScore}
                      className="sidebartogglexyz"
                    >
                      Update NISM Scores
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <button className="dropdown-btn sidebartogglexyz">
                    <i
                      className="fa fa-edit sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    Update Bulk NISM Profile Create
                    <i className="fa fa-caret-down sidebartogglexyz"></i>
                  </button>

                  <div className="dropdown-container sidebartogglexyz">
                    <a
                      href
                      onClick={this.uploadNism}
                      className="sidebartogglexyz"
                    >
                      Update Bulk NISM Profile Create
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <button className="dropdown-btn sidebartogglexyz">
                    <i
                      className="fa fa-edit sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    OPS Upload
                    <i className="fa fa-caret-down sidebartogglexyz"></i>
                  </button>

                  <div className="dropdown-container sidebartogglexyz">
                    <a
                      href
                      onClick={this.updatePayment}
                      className="sidebartogglexyz"
                    >
                      Update Workflow to Payment Complete
                    </a>
                    <a
                      href
                      onClick={this.nigoMark}
                      className="sidebartogglexyz"
                    >
                      Upload NIGO Marking
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}

              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <a
                    href
                    onClick={this.CamsApiIntegration}
                    className="sidebartogglexyz"
                  >
                    <i
                      className="fa fa-edit sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    CAMS Api Integration
                  </a>
                </div>
              ) : (
                ""
              )}
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <button className="dropdown-btn sidebartogglexyz">
                    <i
                      className="fa fa-edit sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    Update Bulk NISM Exam Date
                    <i className="fa fa-caret-down sidebartogglexyz"></i>
                  </button>
                  <div className="dropdown-container sidebartogglexyz">
                    <a
                      href
                      onClick={this.uploadExamDate}
                      className="sidebartogglexyz"
                    >
                      Update Bulk NISM Exam Date
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <a
                    href
                    onClick={this.updatePersonalDetails}
                    className="sidebartogglexyz"
                  >
                    <i
                      className="fa fa-edit sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    Update Personal Details
                  </a>
                </div>
              ) : (
                ""
              )}
              {[6, "6"].includes(localStorage.getItem("roleId")) ? (
                <div>
                  <button className="dropdown-btn sidebartogglexyz">
                    <i
                      className="fa fa-book sidebartogglexyz"
                      aria-hidden="true"
                    ></i>{" "}
                    Reports
                    <i className="fa fa-caret-down sidebartogglexyz"></i>
                  </button>

                  <div className="dropdown-container sidebartogglexyz">
                    <a
                      href
                      onClick={this.mandateReport}
                      className="sidebartogglexyz"
                    >
                      Mandate Details
                    </a>
                    <a
                      href
                      onClick={this.feedBack}
                      className="sidebartogglexyz"
                    >
                      Feedback Report
                    </a>
                    <a
                      href
                      onClick={this.getInTouch}
                      className="sidebartogglexyz"
                    >
                      Get in Touch Report
                    </a>
                    <a
                      href
                      onClick={this.camsEuinReport}
                      className="sidebartogglexyz"
                    >
                      Cams EUIN Report
                    </a>
                    <a
                      href
                      onClick={this.camsEuinErrorReport}
                      className="sidebartogglexyz"
                    >
                      Cams EUIN Error Report
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </React.Fragment>

          <Formik
            enableReinitialize={true}
            initialValues={{
              emailid: JSON.parse(localStorage.getItem("login"))["emailId"],
              partyid: JSON.parse(localStorage.getItem("login"))["partyId"],
              feedbackMsg: this.state.feedbackMsg,
              rank: this.state.rank,
              typeOfConcernList:
                this.state.typeOfConcernList || this.state.typeOfConcernList1,
              typeOfConcern: "",
            }}
            validationSchema={Yup.object().shape({
              rank: Yup.number()
                .min(1, "You must specify your reaction")
                .max(5, "rating range should be between 1-5"),
              feedbackMsg: Yup.string().matches(
                /^[a-zA-Z0-9\s,\-&./()]+$/,
                "Please enter valid Feedback Message. Allowed characters : alphnumeric,Space,comma,hyphen,ampersand,dot,forward Slash, Round Brackets",
              ),
              typeOfConcern: Yup.string().when("rank", {
                is: (rank) => (rank === 1 || rank === 2 ? true : false),
                then: Yup.string().required("You Must Select Type of Concern"),
                otherwise: Yup.string(),
              }),
            })}
            onSubmit={(values) => {
              if (values.emailid === "") {
                warning("EmailId can't be null", warningNotification);
                return;
              } else if (values.partyid === "") {
                warning("partyId can't be null", warningNotification);
                return;
              }
              let data = {
                partyid: values.partyid,
                emailid: values.emailid,
                rank: values.rank,
                feedback_msg: values.feedbackMsg,
                concernID: values.typeOfConcern,
              };
              this.setState({ loading: true, saveFeedbackBtnDisabled: true });
              FeedbackService.PostFeedback(
                data,
                (cb) => {
                  if (cb.status === "success") {
                    this.setState({
                      loading: false,
                      saveFeedbackBtnDisabled: false,
                      rank: 0,
                      feedbackMsg: "",
                    });
                    success(
                      "Thank you for your valuable Feedback!",
                      successNotification,
                    );
                    window.$("#feedback-modal").modal("hide");
                    const child = document.querySelectorAll(".emoji");
                    child.forEach((element) => {
                      element.classList.remove("active");
                    });
                  } else {
                    error(cb.status, errorNotification);
                    window.$("#feedback-modal").modal("hide");
                    this.setState({
                      loading: false,
                      saveFeedbackBtnDisabled: false,
                      rank: 0,
                      feedbackMsg: "",
                    });
                    const child = document.querySelectorAll(".emoji");
                    child.forEach((element) => {
                      element.classList.remove("active");
                    });
                  }
                },
                (err) => console.error("Error", err),
              );
            }}
            render={({
              errors,
              touched,
              handleSubmit,
              values,
              handleChange,
            }) => (
              <React.Fragment>
                <div
                  className="modal fade"
                  id="feedback-modal"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="myModalLabel"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.handleClose}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>

                        <strong>
                          <h4
                            className="modal-title text-center"
                            style={{ fontWeight: "bold", marginBottom: 20 }}
                            id="myModalLabel"
                          >
                            How was your overall experience with RCP?
                          </h4>
                        </strong>
                      </div>
                      <div className="modal-body">
                        <Form className="form-group">
                          <div className="form-group">
                            <div className="row">
                              <div
                                id="myDIV"
                                className="col-md-12 col-sm-12 col-xs-12 text-center"
                              >
                                <span
                                  name="rank"
                                  role="img"
                                  aria-label="Emoji"
                                  className="emoji"
                                  onClick={() => {
                                    this.setState({ rank: 1 });
                                  }}
                                >
                                  &#128544;
                                </span>
                                <span
                                  name="rank"
                                  role="img"
                                  aria-label="Emoji"
                                  className="emoji"
                                  onClick={() => {
                                    this.setState({ rank: 2 });
                                  }}
                                >
                                  &#128530;
                                </span>
                                <span
                                  name="rank"
                                  role="img"
                                  aria-label="Emoji"
                                  className="emoji"
                                  onClick={() => {
                                    this.setState({ rank: 3 });
                                  }}
                                >
                                  &#128529;
                                </span>
                                <span
                                  name="rank"
                                  role="img"
                                  aria-label="Emoji"
                                  className="emoji"
                                  onClick={() => {
                                    this.setState({ rank: 4 });
                                  }}
                                >
                                  &#128512;
                                </span>
                                <span
                                  name="rank"
                                  role="img"
                                  aria-label="Emoji"
                                  className="emoji"
                                  onClick={() => {
                                    this.setState({ rank: 5 });
                                  }}
                                >
                                  &#129321;
                                </span>
                              </div>
                              <ErrorMessage
                                name="rank"
                                className="validation"
                                component="div"
                                style={{ marginLeft: "42px" }}
                              />
                            </div>
                            {["1", 1, "2", 2].includes(this.state.rank) && (
                              <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                                  <label>
                                    Type Of Concern
                                    <span className="validation"> * </span>
                                  </label>
                                  <Field
                                    as="select"
                                    name="typeOfConcern"
                                    id="typeOfConcern"
                                    style={{
                                      border: "1px solid #fbc583",
                                      width: "90%",
                                      margin: "0px 5px 5px 3rem",
                                    }}
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.typeOfConcern &&
                                      touched.typeOfConcern
                                        ? " is-invalid"
                                        : "")
                                    }
                                  >
                                    <option value="">--Select--</option>
                                    {(values.typeOfConcernList || []).map(
                                      (item) => (
                                        <option
                                          key={item.concernID}
                                          value={item.concernID}
                                        >
                                          {item.concernName}
                                        </option>
                                      ),
                                    )}
                                  </Field>
                                  <ErrorMessage
                                    name="typeOfConcern"
                                    component="div"
                                    className="validation"
                                  />
                                </div>
                              </div>
                            )}
                            <div className="row">
                              <div className="col-md-12 col-sm-12 col-xs-12 mt-10">
                                <Field
                                  rows="4"
                                  component="textarea"
                                  maxLength={255}
                                  name="feedbackMsg"
                                  id="feedbackMsg"
                                  placeholder="What can we do to improve?"
                                  autoComplete="feedbackMsg"
                                  onChange={handleChange}
                                  className={"form-control"}
                                  style={{
                                    border: "1px solid #fbc583",
                                    width: "90%",
                                    margin: "0px 5px 5px 3rem",
                                  }}
                                />
                                <ErrorMessage
                                  name="feedbackMsg"
                                  className="validation"
                                  component="div"
                                  style={{ marginLeft: "42px" }}
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                      <div className="modal-footer text-center">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={this.state.saveFeedbackBtnDisabled}
                          onClick={handleSubmit}
                        >
                          Send your Feedback
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
          />
        </div>
      );
    }
  },
);

export default DashboardHeader;
